module.exports = new __parcel__URL__("overview.5e43ba7d.png").toString();